function filterProducts(cat, btn) {
  // Update active button state
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
 
  // Filter product cards — hide non-matching, animate only matching
  const cards = document.querySelectorAll('.product-card');
  let visibleIndex = 0;
 
  cards.forEach(card => {
    const cardCat = card.dataset.cat || '';
    const tags = cardCat.trim().split(/\s+/);
    const show = cat === 'all' || tags.includes(cat);
 
    if (show) {
      card.style.display = '';
      card.style.animation = 'none';
      card.offsetHeight; // reflow
      card.style.animation = `fadeUp 0.35s ease ${visibleIndex * 0.06}s both`;
      visibleIndex++;
    } else {
      card.style.display = 'none';
      card.style.animation = 'none';
    }
  });
}
 
// Mobile Menu Toggle Logic
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.menu-toggle');
  const navLinks = document.querySelector('.nav-links');
 
  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', function() {
      navLinks.classList.toggle('active');
      
      // Optional: Animate hamburger icon
      const spans = menuToggle.querySelectorAll('span');
      if (navLinks.classList.contains('active')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(4px, -4px)';
      } else {
        spans[0].style.transform = 'none';
        spans[1].style.opacity = '1';
        spans[2].style.transform = 'none';
      }
    });
  }
});
 
// Add CSS for fadeUp animation if not in CSS file
if (!document.getElementById('formiv-animations')) {
  const style = document.createElement('style');
  style.id = 'formiv-animations';
  style.innerHTML = `
    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(style);
}